import { render, staticRenderFns } from "./Detail.vue?vue&type=template&id=2a3e2a7f&scoped=true"
import script from "./Detail.vue?vue&type=script&lang=js"
export * from "./Detail.vue?vue&type=script&lang=js"
import style0 from "./Detail.vue?vue&type=style&index=0&id=2a3e2a7f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a3e2a7f",
  null
  
)

export default component.exports